import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Button,
  Card
} from "react-onsenui";
import LoginScreen from "./LoginScreen";
import CreateTenderScreen from "./CreateTenderScreen";
import ListTendersScreen from "./ListTenderScreen";
import ShowQuotesScreen from "./ShowQuotesScreen";
import {
  ChatOption,
  CirclePlay,
  Copy,
  SettingsOption,
  Logout,
  RadialSelected
} from "grommet-icons";
import Nav from "./Nav";
import { Navbar } from "..";
import { useTranslation } from "react-i18next";
import "../i18n.js";
import i18n from "../i18n.js";
import Dialog from "./AlertDialog.js";
import UploadClaimStatus from "./UploadClaimStatus.js";


import { useKeycloak } from "@react-keycloak/web";




const HomeScreen = ({ navigator, setIsLoggedIn }) => {

  const { keycloak } = useKeycloak();


  const { t } = useTranslation();
  const [language, setLanguage] = useState("en");
  const [organization, setOrganization] = useState({
    name: "",
    id: "",
  });
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [key, setKey] = useState(0);

  useEffect(() => {
    i18n.changeLanguage(language).then(() => {
      setKey((prevKey) => prevKey + 1); // Trigger re-render on language change
    });
    
    loadOrganizationDetails();
  }, [language]);

  const loadOrganizationDetails = () => {
    const orgName = Cookies.get("org_name");
    const orgId = Cookies.get("org_id");

    if (orgName && orgId) {
      setOrganization({ name: orgName, id: orgId });
    }
  };

  const clearOrganizationDetails = () => {
    Cookies.remove("RATIFI_REDUX_TOKEN");
    setOrganization({ name: "", id: "" });
  };

  const handleLogout = () => {
    setDialogMessage(t("Are you sure you want to logout?"));
    setDialogVisible(true);
  };

  const confirmLogout = () => {
    setIsLoggedIn(false);
    clearOrganizationDetails();


    keycloak.logout({
      redirectUri: "https://operatrack.nubits.net/", // Change to your home URL
    });
    // navigator.pushPage({
    //   key:"Login",
    //   title: "Login",
    //   component: LoginScreen,
    // });

    
  };

  const handleCreateTender = () => {
    navigator.pushPage({
      title: <Nav title={t("Upload Claim Status")} />,
      component: UploadClaimStatus,
      isRenderToolbar: true,
    });
  };

  const handleListTenders = () => {
    navigator.pushPage({
      title: <Nav title={t("Video Tutorials")} />,
      component: ListTendersScreen,
      isRenderToolbar: true,
    });
  };

  const handleShowQuotes = () => {
    navigator.pushPage({
      title: <Nav title={t("Help & Support")} />,
      component: ShowQuotesScreen,
      isRenderToolbar: true,
    });
  };

  return (
    <div
      style={{
        textAlign: "center",
        background: "#eee",
        paddingBottom: 10,
        height: "100vh",
      }}
      key={key} // Use key to force re-render on language change
    >
      <Navbar language={language} setLanguage={setLanguage} />
      <div style={{ padding: "20px" }}>
        <Card style={{ padding: 10 }}>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
            <div
              onClick={handleCreateTender}
              style={{ width: 80, height: 100, margin: 5 }}
            >
              <div
                style={{
                  padding: "15px 10px",
                  border: "solid 3px  #5C7232",
                  background: "#5C7232",
                  borderRadius: 20,
                  textAlign: "center",
                }}
              >
                <Copy color="white" size="medium" />
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#5C7232",
                  textAlign: "center",
                }}
              >
                {t("Digital Record")}
              </div>
            </div>

            <div
              onClick={handleListTenders}
              style={{ width: 80, height: 100, margin: 5 }}
            >
              <div
                style={{
                  padding: "15px 10px",
                  border: "solid 3px #5C7232",
                  background: "#5C7232",
                  borderRadius: 20,
                  textAlign: "center",
                }}
              >
                <CirclePlay color="white" size="medium" />
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#5C7232",
                  textAlign: "center",
                }}
              >
                {t("Video Tutorials")}
              </div>
            </div>

            <div
              onClick={handleShowQuotes}
              style={{ width: 80, height: 100, margin: 5 }}
            >
              <div
                style={{
                  padding: "15px 10px",
                  border: "solid 3px  #5C7232",
                  background: "#5C7232",
                  borderRadius: 20,
                  textAlign: "center",
                }}
              >
                <ChatOption color="white" size="medium" />
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#5C7232",
                  textAlign: "center",
                }}
              >
                {t("Help & Support")}
              </div>
            </div>
{/* 
            <div
              onClick={handleShowQuotes}
              style={{ width: 80, height: 100, margin: 5 }}
            >
              <div
                style={{
                  padding: "15px 10px",
                  border: "solid 3px  #5C7232",
                  background: "#5C7232",
                  borderRadius: 20,
                  textAlign: "center",
                }}
              >
                <SettingsOption color="white" size="medium" />
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#5C7232",
                  textAlign: "center",
                }}
              >
                {t("Profile & Settings")}
              </div>
            </div> */}
          </div>
        </Card>
      </div>
{/* 
      <div>
        <div className="mt-2">
          {t("Internet")} -
          <b style={{ color: "green" }}>
            <span>{t("Connected")}</span>
            <span>
              [<RadialSelected size="small" color="green" />]
            </span>
          </b>
        </div>
        <div className="mt-2">
          {t("Sync")} - <b style={{ color: "green" }}>{t("Completed")}</b>
        </div>
      </div> */}

      <div>
        <Button
          onClick={handleLogout}
          style={{ marginTop: 10, color: "white", background: "#5C7232" }}
        >       
          <Logout color="white" size="small" /> {" "}
          <span style={{ fontSize: "14px" }}>{t("Logout")}</span>
        </Button>
      </div>

      {/* Dialog component for logout confirmation */}
      <Dialog
        visible={dialogVisible}
        setVisible={setDialogVisible}
        title={t("Logout")}
        desc={dialogMessage}
        onConfirm={confirmLogout}
      />
    </div>
  );
};

export default HomeScreen;